import { textFilter } from "react-bootstrap-table2-filter";
import { FieldParams } from "../../core/FieldObject";
import {
  DeepMergeObject,
  DotStringToObject,
  GetHeaderStyle,
  GetNormalStyle,
  PostJson,
} from "../../core/Helper";
import { FieldDataType, FormControlType } from "../../core/Helper2";
import { BuildsColumnsWithEdit } from "../../core/TableHelper";

export const FormType = {
  /** ฟอร์มนัด */
  APPOINTMENT: 1,
  INVOICE: 2,
  RECEIPT: 3,
  BILLING_NOTE: 4,
  GOOD_RECEIVE: 5,
  GOOD_SUPPLY: 6,
  PAYDF_RAD: 20,
};

export const DocuTypeMini = {
  DocuTypeId: {
    ...new FieldParams(
      "DocuTypeId",
      "DocuTypeID",
      true,
      FieldDataType.NUMERIC,
      FormControlType.HIDDEN
    ),
    isHiddenColumn: true,
  },
  DocuTypeCode: {
    ...new FieldParams("DocuTypeCode", "รหัส", true),
  },
  DocuTypeName: new FieldParams("DocuTypeName", "ชื่อเอกสาร", true),
};

//**DOCU OBJECT */
export const DocuTypeObj = {
  DocuTypeId: {
    ...new FieldParams(
      "DocuTypeId",
      "DocuTypeID",
      true,
      FieldDataType.NUMERIC,
      FormControlType.HIDDEN
    ),
    isHiddenColumn: true,
  },
  DocuTypeCode: {
    ...new FieldParams("DocuTypeCode", "รหัส", true),
  },
  DocuTypeName: new FieldParams("DocuTypeName", "ชื่อเอกสาร", true),
  DocuTypeText: new FieldParams("DocuTypeText", "ข้อความหัวเอกสาร", true),
  RunningFormat: {
    ...new FieldParams(
      "RunningFormat",
      "Format",
      true,
      FieldDataType.TEXT,
      FormControlType.SELECT
    ),
    selectData: [
      { id: "yy", value: "YY" },
      { id: "yymm", value: "YYMM" },
      { id: "yymmdd", value: "YYMMDD" },
    ],
    selectHasFirstOption: false,
    selectValueOnly: true,
  },
  DocuDirection: {
    ...new FieldParams(
      "DocuDirection",
      "ฟอร์มการใช้งาน",
      false,
      FieldDataType.NUMERIC,
      FormControlType.SELECT
    ),
    selectData: [
      { id: FormType.APPOINTMENT, value: "การนัดตรวจ" },
      { id: FormType.INVOICE, value: "ใบแจ้งหนี้/Invoice" },
      { id: FormType.RECEIPT, value: "รับเงิน/Receipt" },
      { id: FormType.BILLING_NOTE, value: "การวางบิล/Billing" },
      { id: FormType.GOOD_RECEIVE, value: "การรับสินค้าเข้า" },
      { id: FormType.GOOD_SUPPLY, value: "การจ่ายสินค้า" },
    ],
    selectValueOnly: true,
    selectHasFirstOption: false,
  },
  RunningDigits: {
    ...new FieldParams(
      "RunningDigits",
      "จำนวนหลัก",
      true,
      FieldDataType.NUMERIC,
      FormControlType.NUMERIC
    ),
  },
  RunningPrefix: {
    ...new FieldParams("RunningPrefix", "ข้อความขึ้นต้น"),
  },
  RunningSuffix: {
    ...new FieldParams("RunningSuffix", "ข้อความต่อท้าย"),
  },

  DocuTypeRemark: {
    ...new FieldParams(
      "DocuTypeRemark",
      "หมายเหตุ",
      true,
      FieldDataType.TEXT,
      FormControlType.TEXT_AREA
    ),
  },

  StockFlag: {
    ...new FieldParams(
      "StockFlag",
      "ตัดสต๊อก",
      true,
      FieldDataType.BOOLEAN,
      FormControlType.CHECK_BOX
    ),
  },
  TaxReportFlag: {
    ...new FieldParams(
      "TaxReportFlag",
      "สรุปภาษี",
      true,
      FieldDataType.BOOLEAN,
      FormControlType.CHECK_BOX
    ),
  },
};

/** SERVICE */
export class DocuTypeService {
  static async GetList(data, user) {
    let result = await PostJson("/api/docu-type/getlist", {
      data,
      user,
    });
    return result ?? null;
  }
  static async GetItem(data, user) {
    let result = await PostJson("/api/docu-type/getitem", {
      data,
      user,
    });
    return result ?? null;
  }

  static async SaveItem(data, user) {
    let result = await PostJson("/api/docu-type/update", {
      data,
      user,
    });
    return result ?? null;
  }

  static async DeleteItem(data, user) {
    let result = await PostJson("/api/docu-type/delete", {
      data,
      user,
    });
    return result ?? null;
  }

  static GetColumns(clazz, OnEditClick, OnDeleteClick) {
    return BuildsColumnsWithEdit(clazz, OnEditClick, OnDeleteClick);
  }
}

export const SearchDocuType = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;
  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "docu_type_id";
  const displayFieldName = "docu_type_name";

  setSearchB({
    title: "ประเภทเอกสาร",
    size: "sm",
    show: true,
    fieldId: idFieldName,
    fieldName: "docu_type_name",
    sql: {
      fields: ["docu_type_id", "docu_type_code", "docu_type_name"],
      tableName: "docu_type a ",
      defaultCriteria: " a.del_flag ='n' ",
      criteriaFields: ["a.docu_type_code", "a.docu_type_name"],
      criteriaText: "",
      orderBy: ["a.docu_type_name"],
      maxRows: 1000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "docu_type_code",
        text: "รหัส",
        sort: true,
        headerStyle: GetHeaderStyle("120px"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "docu_type_name",
        text: "ประเภทเอกสาร",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};
